
(function () {
  var terms = [
    'grid mesh panels',
    'slatwall hooks',
    'clothes rails',
    'mannequins',
    'pavement signs',
    'retail display hooks',
    'carrier bags',
    'price guns',
    'till rolls',
    'wire shelving'
  ];

  var typingSpeed = 54;
  var deletingSpeed = 28;
  var holdTime = 1700;
  var betweenTime = 260;

  function setTypedText(el, text) {
    el.innerHTML = 'Search for <strong>' + text.replace(/[&<>'"]/g, function (c) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c];
    }) + '</strong>';
  }



  function updateMobileDropdownTop(form) {
    var header = document.getElementById('shopify-section-header');
    var searchWrap = form ? form.closest('predictive-search') : null;
    var rect = searchWrap ? searchWrap.getBoundingClientRect() : (header ? header.getBoundingClientRect() : null);
    if (!rect) return;
    var top = Math.max(8, Math.round(rect.bottom + 8));
    document.documentElement.style.setProperty('--s2g-search-dropdown-top', top + 'px');
  }

  function initAnimatedSearch(form) {
    if (!form || form.dataset.s2gAnimatedReady === 'true') return;
    var input = form.querySelector('input[type="search"][data-s2g-animated-search]');
    var placeholder = form.querySelector('.s2g-search-typed-placeholder');
    if (!input || !placeholder) return;

    form.dataset.s2gAnimatedReady = 'true';
    var index = 0;
    var charIndex = 0;
    var deleting = false;
    var timer = null;

    function syncState() {
      form.classList.toggle('s2g-has-value', input.value.trim().length > 0);
      input.dataset.s2gActiveTerm = terms[index] || terms[0];
    }

    function step() {
      var term = terms[index] || terms[0];
      input.dataset.s2gActiveTerm = term;

      if (input.value.trim().length > 0 || document.activeElement === input) {
        syncState();
        timer = window.setTimeout(step, 350);
        return;
      }

      if (!deleting) {
        charIndex = Math.min(charIndex + 1, term.length);
        setTypedText(placeholder, term.slice(0, charIndex));
        if (charIndex === term.length) {
          deleting = true;
          timer = window.setTimeout(step, holdTime);
        } else {
          timer = window.setTimeout(step, typingSpeed);
        }
      } else {
        charIndex = Math.max(charIndex - 1, 0);
        setTypedText(placeholder, term.slice(0, charIndex));
        if (charIndex === 0) {
          deleting = false;
          index = (index + 1) % terms.length;
          input.dataset.s2gActiveTerm = terms[index];
          timer = window.setTimeout(step, betweenTime);
        } else {
          timer = window.setTimeout(step, deletingSpeed);
        }
      }
    }

    input.addEventListener('focus', function () {
      form.classList.add('s2g-search-focused');
      updateMobileDropdownTop(form);
      syncState();
    });

    input.addEventListener('blur', function () {
      form.classList.remove('s2g-search-focused');
      syncState();
    });

    input.addEventListener('input', function () {
      updateMobileDropdownTop(form);
      syncState();
    });

    form.addEventListener('submit', function () {
      if (!input.value.trim()) {
        var activeTerm = input.dataset.s2gActiveTerm || terms[index] || terms[0];
        input.value = activeTerm;
        form.classList.add('s2g-has-value');
      }
    }, true);

    syncState();
    setTypedText(placeholder, '');
    timer = window.setTimeout(step, 250);
  }

  function initAll() {
    document.querySelectorAll('form.s2g-animated-search').forEach(initAnimatedSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('resize', function () {
    document.querySelectorAll('form.s2g-animated-search').forEach(updateMobileDropdownTop);
  });

  document.addEventListener('shopify:section:load', initAll);
})();

/* S2G desktop live search hard fix
   This uses its own floating dropdown on desktop so results cannot be clipped by header/search containers. */
(function () {
  var DESKTOP_QUERY = '(min-width: 990px)';
  var activeForm = null;
  var activeInput = null;
  var activeController = null;
  var cache = {};
  var debounceTimer = null;

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function ensurePanel() {
    var panel = document.querySelector('.s2g-desktop-live-search-panel');
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 's2g-desktop-live-search-panel';
      panel.setAttribute('role', 'listbox');
      panel.setAttribute('aria-label', 'Search results');
      document.body.appendChild(panel);

      panel.addEventListener('mousedown', function (event) {
        event.preventDefault();
      });

      panel.addEventListener('click', function (event) {
        var viewAll = event.target.closest('.s2g-predictive-view-all-btn, .predictive-search__item--term');
        if (viewAll && activeInput) {
          event.preventDefault();
          var term = activeInput.value.trim() || activeInput.dataset.s2gActiveTerm || '';
          if (term) window.location.href = '/search?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
        }
      });
    }
    return panel;
  }

  function closePanel() {
    var panel = document.querySelector('.s2g-desktop-live-search-panel');
    if (panel) {
      panel.classList.remove('is-open', 'is-loading');
      panel.innerHTML = '';
    }
    document.body.classList.remove('s2g-desktop-live-search-open');
  }

  function positionPanel(form) {
    if (!form || !isDesktop()) return;
    var panel = ensurePanel();
    var rect = form.getBoundingClientRect();
    var width = Math.min(960, Math.max(rect.width * 1.85, 760));
    var left = rect.left;

    if (width > window.innerWidth - 32) {
      width = window.innerWidth - 32;
    }

    if (left + width > window.innerWidth - 16) {
      left = Math.max(16, window.innerWidth - width - 16);
    }

    panel.style.left = Math.round(left) + 'px';
    panel.style.top = Math.round(rect.bottom + 10) + 'px';
    panel.style.width = Math.round(width) + 'px';
  }

  function renderLoading(form, term) {
    var panel = ensurePanel();
    positionPanel(form);
    panel.classList.add('is-open', 'is-loading');
    panel.innerHTML = '<div class="s2g-live-loading"><span class="s2g-live-spinner"></span>Search results for “' + escapeHtml(term) + '”</div>';
    document.body.classList.add('s2g-desktop-live-search-open');
  }

  function escapeHtml(text) {
    return String(text || '').replace(/[&<>"']/g, function (c) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function normaliseMarkup(markup, term) {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = markup || '';

    wrapper.querySelectorAll('[id]').forEach(function (el) {
      el.removeAttribute('id');
    });

    var heading = wrapper.querySelector('.predictive-search__heading');
    if (heading) {
      var spinner = heading.querySelector('.spinner');
      heading.textContent = 'Search results for “' + term + '”';
      if (spinner) heading.appendChild(spinner);
    }

    var header = wrapper.querySelector('.s2g-predictive-header');
    if (!header) {
      header = document.createElement('div');
      header.className = 's2g-predictive-header';
      header.innerHTML = '<h2 class="predictive-search__heading">Search results for “' + escapeHtml(term) + '”</h2><span class="s2g-predictive-query">Click a product or view all</span>';
      wrapper.prepend(header);
    }

    var list = wrapper.querySelector('.s2g-predictive-grid, .predictive-search__results-list');
    if (!list) {
      wrapper.innerHTML = '<div class="s2g-predictive-header"><h2 class="predictive-search__heading">Search results for “' + escapeHtml(term) + '”</h2></div><div class="s2g-live-empty">No products found. Try a different search term.</div><div class="s2g-predictive-view-all"><button class="predictive-search__item predictive-search__item--term s2g-predictive-view-all-btn">View all results for “' + escapeHtml(term) + '”</button></div>';
    }

    wrapper.querySelectorAll('a.s2g-predictive-product-card, a.predictive-search__item--link').forEach(function (a) {
      a.setAttribute('tabindex', '0');
    });
    wrapper.querySelectorAll('button.s2g-predictive-view-all-btn, button.predictive-search__item--term').forEach(function (btn) {
      btn.setAttribute('tabindex', '0');
    });

    return wrapper.innerHTML;
  }

  function fetchResults(form, input, term) {
    if (!isDesktop()) return;
    if (!term) {
      closePanel();
      return;
    }

    activeForm = form;
    activeInput = input;
    positionPanel(form);

    var key = term.toLowerCase();
    if (cache[key]) {
      var panel = ensurePanel();
      panel.innerHTML = cache[key];
      panel.classList.remove('is-loading');
      panel.classList.add('is-open');
      document.body.classList.add('s2g-desktop-live-search-open');
      positionPanel(form);
      return;
    }

    if (activeController) activeController.abort();
    activeController = new AbortController();
    renderLoading(form, term);

    var endpoint = (window.routes && routes.predictive_search_url ? routes.predictive_search_url : '/search/suggest');
    var url = endpoint + '?q=' + encodeURIComponent(term) + '&resources%5Btype%5D=product&resources%5Blimit%5D=6&section_id=predictive-search';

    fetch(url, { signal: activeController.signal })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var section = doc.querySelector('#shopify-section-predictive-search');
        var raw = section ? section.innerHTML : text;
        var html = normaliseMarkup(raw, term);
        cache[key] = html;
        var panel = ensurePanel();
        panel.innerHTML = html;
        panel.classList.remove('is-loading');
        panel.classList.add('is-open');
        document.body.classList.add('s2g-desktop-live-search-open');
        positionPanel(form);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        var panel = ensurePanel();
        panel.innerHTML = '<div class="s2g-live-empty">Search results could not load. Press Enter to search.</div>';
        panel.classList.remove('is-loading');
        panel.classList.add('is-open');
        positionPanel(form);
      });
  }

  function bindForm(form) {
    if (!form || form.dataset.s2gDesktopLiveReady === 'true') return;
    var input = form.querySelector('input[type="search"]');
    if (!input) return;
    form.dataset.s2gDesktopLiveReady = 'true';

    input.addEventListener('input', function () {
      if (!isDesktop()) return;
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () {
        fetchResults(form, input, input.value.trim());
      }, 180);
    });

    input.addEventListener('focus', function () {
      if (!isDesktop()) return;
      var term = input.value.trim();
      if (term) fetchResults(form, input, term);
    });

    input.addEventListener('keydown', function (event) {
      if (!isDesktop()) return;
      var panel = document.querySelector('.s2g-desktop-live-search-panel.is-open');
      if (!panel) return;
      if (event.key === 'Escape') {
        closePanel();
        input.blur();
      }
    });

    form.addEventListener('submit', function () {
      if (!input.value.trim()) {
        var activeTerm = input.dataset.s2gActiveTerm || 'grid mesh panels';
        input.value = activeTerm;
      }
    }, true);
  }

  function bindAll() {
    document.querySelectorAll('#shopify-section-header form.s2g-animated-search, #shopify-section-header form.search-header').forEach(bindForm);
  }

  document.addEventListener('click', function (event) {
    var panel = document.querySelector('.s2g-desktop-live-search-panel');
    if (!panel || !panel.classList.contains('is-open')) return;
    if (panel.contains(event.target)) return;
    if (activeForm && activeForm.contains(event.target)) return;
    closePanel();
  });

  window.addEventListener('resize', function () {
    if (!isDesktop()) {
      closePanel();
    } else if (activeForm) {
      positionPanel(activeForm);
    }
  });

  window.addEventListener('scroll', function () {
    if (activeForm && document.body.classList.contains('s2g-desktop-live-search-open')) {
      positionPanel(activeForm);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', bindAll);
})();
